/* ============================================================
   c-header : スクロール状態の判定クラス（is-scrolled）
   ------------------------------------------------------------
   テーマ既定の .header--transparent は「hover」でも「スクロール」でも
   外れるため、レイアウト寸法の判定には使えない
   （hover のたびにロゴ・ヘッダー高が変わってガタつく）。
   スクロール由来かどうかだけを表すクラスを別途付与し、
   CSS 側は「下層ページ」または「スクロール後」で小型化する。
   閾値はテーマの transparentHeaderThreshold（25px）と揃える。
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('store-header.c-header');
  if (!header) return;

  const THRESHOLD = 25;
  let ticking = false;

  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ----------------------------------------------------------
     メニュー（ドロワー）を開いている間は「追従時のヘッダー」を表示する。
     透過解除はテーマ既定の isTransparencyDetectionLocked を立てて
     _checkTransparentHeader() を呼ぶ（テーマ側の判定と競合させないため）。
     開閉の検知はトグルボタンの aria-expanded を監視する。
     ---------------------------------------------------------- */
  const drawerToggle = document.querySelector('[aria-controls="mobile-menu-drawer"]');
  if (!drawerToggle) return;

  const setDrawerState = (isOpen) => {
    header.isTransparencyDetectionLocked = isOpen;

    if (typeof header._checkTransparentHeader === 'function') {
      header._checkTransparentHeader();
    }

    if (isOpen) {
      header.classList.add('is-scrolled');
    } else {
      update();
    }
  };

  new MutationObserver(() => {
    setDrawerState(drawerToggle.getAttribute('aria-expanded') === 'true');
  }).observe(drawerToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
});
